import React from "react";
import Chart from "react-apexcharts";
import {
  expenseCategories,
  expensesByMonth,
  expensesByMonthAndCategory,
  expensesByCategoryAndMonth,
  formatMoney,
  total,
} from "../expense_utils";

export default ({ expenses }) => {
  // const byMonthAndCategory = expensesByMonthAndCategory(expenses);
  // const byMonth = expensesByMonth(expenses);

  // const months = Object.keys(byMonthAndCategory);
  // const categories = expenseCategories(expenses);
  // // formatMoney(total(expenses))
  // console.log({ categories, byMonthAndCategory, byMonth });

  const byCategoryAndMonth = expensesByCategoryAndMonth(expenses);
  const allMonths = Object.keys(expensesByMonth(expenses));

  // const chartSeries = [
  //   {
  //     name: "South",
  //     data: [["2019-08-23", 2], ["2019-08-24", 2], ["2019-08-25", 5]],
  //   },
  // ];

  let chartSeries = Object.entries(byCategoryAndMonth).map(
    ([category, months]) => {
      const data = allMonths.map(month => {
        return [month, Math.abs(total(months[month]).toFixed(2)) || 0];
      });
      // const data = Object.entries(months).map(([date, expenses]) => [
      //   date,
      //   Math.abs(total(expenses).toFixed(2)) || 0,
      // ]);
      return { name: category, data };
    }
  );

  console.log({ chartSeries });

  // chartSeries = chartSeries.slice(0, 8);

  const chartOptions = {
    chart: {
      stacked: true,
      events: {
        selection: (chart, e) => {
          console.log(new Date(e.xaxis.min));
        },
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
      },
    },
    colors: [
      "#A0AEC0",
      "#F56565",
      "#ED8936",
      "#ECC94B",
      "#48BB78",
      "#38B2AC",
      "#4299E1",
      "#667EEA",
      "#9F7AEA",
      "#ED64A6",
    ],
    dataLabels: {
      enabled: true,
    },
    stroke: {
      curve: "straight",
    },
    // fill: {
    //   type: "gradient",
    //   gradient: {
    //     opacityFrom: 0.6,
    //     opacityTo: 0.8,
    //   },
    // },
    legend: {
      position: "bottom",
      horizontalAlign: "left",
    },
    xaxis: {
      type: "datetime",
      labels: {
        format: "yyyy-MM",
      },
    },
    tooltip: {
      x: {
        format: "yyyy-MM",
      },
      fixed: {
        enabled: false,
        position: "topRight",
      },
    },
  };

  return (
    <div className="w-full">
      <Chart
        options={chartOptions}
        series={chartSeries}
        type="bar"
        height={1000}
      />
    </div>
  );
};
